import { Vue, Prop, Component } from "@wagich/vue-facing-decorator-metadata";

import { render } from "./team-filter.html";
import { TeamFilterCard } from "./team-filter-card";
import { type Person, Role, type PersonListItem } from "../models/Person";
import { type ListModel } from "../models/ListModel";

const FilterCategories: { label: string, value: string }[] = [
	{ label: "Lehrpersonen", value: "teacher" },
	{ label: "Schulleitung", value: "management" },
	{ label: "Vorstand Lehrerkonvent", value: "teachersBoard" },
	{ label: "Administration", value: "administration" },
	{ label: "Vorstand Förderverein", value: "boosterClub" },
	{ label: "Vorstand Trägerverein", value: "sponsoringAssociation" }
];

@Component({
render,
	components: {
		TeamFilterCard
	}
})
export class TeamFilter extends Vue {
	persons: PersonListItem[] = [];
	activeCategoryIndex: number = 0;
    isLoading: boolean = false;

	get categories() {
		return FilterCategories;
	}

	/** The role of the active tab; the cards show only the functions carrying it. */
	get activeRole(): string {
		return FilterCategories[this.activeCategoryIndex].value;
	}

	get filteredPersons(): PersonListItem[] {
		return this.persons.filter(p => p.functions.some(f => f.role == this.activeRole));
	}

	mounted() {
		this.load();
	}

	async load() {
		this.isLoading = true;
		let response = await fetch("/api/persons");
		this.isLoading = false;
		if (response.status >= 300) {
			return;
		}

		let data: ListModel<PersonListItem> = await response.json();
		this.persons = data.items;
	}
}
